import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, OnInit, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { DeviceShadowService } from 'src/app/services/deviceShadow.service';
import { ToastService } from 'src/app/services/toast.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceShadow } from 'src/app/models/deviceShadow.model';
import { FieldStatusEnum } from 'src/app/enums/fieldStatus.enum';
import { AuthService } from 'src/app/services';
import { SecurityProfileEnum } from 'src/app/enums/securityProfile.enum';
import { ErrorCodeEnum } from 'src/app/enums/errorCode.enum';
import { FieldTypeEnum } from 'src/app/enums/fieldType.enum';

export interface ConfigureSensorDialogData {
    id: string;
}

@Component({
  standalone: false,
    selector: 'app-configure-sensor-dialog',
    templateUrl: 'configureSensorDialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['configureSensorDialog.component.scss'],
})
export class ConfigureSensorDialogComponent implements OnInit, OnDestroy {

    isFormLoading = false;
    isLoading = false;
    deviceShadow: DeviceShadow;
    isSuperAdmin = false;
    FieldTypeEnum = FieldTypeEnum;
    FieldStatusEnum = FieldStatusEnum;

    constructor(public dialogRef: MatDialogRef<ConfigureSensorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfigureSensorDialogData,
        private deviceShadowService: DeviceShadowService,
        private authService: AuthService,
        private toastService: ToastService) {

        this.deviceShadow = new DeviceShadow();
        this.isSuperAdmin = this.authService.getCurrentUser().userType === SecurityProfileEnum.SuperAdmin;
    }

    ngOnInit() {
        this.isFormLoading = true;
        this.deviceShadowService.getDeviceShadow(this.data.id)
            .subscribe(
                result => {
                    this.deviceShadow = result;
                    this.isFormLoading = false;
                },
                error => {
                    this.toastService.showError(error);
                    this.isFormLoading = false;
                });
    }

    save() {
        if (this.validate() === false) {
            return;
        }
        this.isLoading = true;
        this.deviceShadowService.updateDeviceShadow(this.deviceShadow)
            .subscribe(
                result => {
                    this.toastService.showSuccess('Device configuration saved successfully', true);
                    this.isLoading = false;
                    this.dialogRef.close();
                }, error => {
                    this.toastService.showError(error);
                    this.isLoading = false;
                });
    }

    validate(): boolean {
        let valid = true;
        this.deviceShadow.fields.forEach(field => {
            if ((field.fieldTypeId === FieldTypeEnum.Float || field.fieldTypeId === FieldTypeEnum.Integer)
                && Number.isNaN(Number(field.value))) {
                valid = false;
                const message = `Invalid number value in field "${field.name}".`;
                this.toastService.showError(message);
            }
        });
        return valid;
    }

    public trackByIndex = trackByIndex;

    ngOnDestroy() {
    }
}
